import * as R from 'ramda';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { IJob } from '../../store/aiearth/types';
import { CeresLogger } from '../../logger';
import { useDispatch, useSelector } from 'react-redux';
import {
  Col,
  Spinner,
  Button,
  Table,
  Tab,
  Tabs,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import styled from 'styled-components';
import { ChevronLeft } from 'react-feather';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import TreeView from './TreeViewData';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import DataTable from 'react-data-table-component';
import { searchAIEarth } from '../../services/firebase';
import { IElasticResult, ISearchRecord } from '../../types/search';
import { Scrollbars } from 'react-custom-scrollbars';
import { IAuthContext } from '../../context/auth/auth-context';
import { TIERS } from '../../types/tiers';
import { toast } from 'react-toastify';
import { updateJob } from '../../store/aiearth/action';
import SoilSummary from './findings/SoilSummary';
import DatabaseDescription from './findings/DatabaseDescription';
import { API_BASE_URL, API_AUTH_HEADERS } from '../../util/api.util';
import { CommonBgColor } from '../custom-styled-components/CommonStyledComponents';
import {
  FINDINGS_OPTIONS,
  getFindingsTypeLabel,
  isAdjoiningFindingsType,
} from './findingsPanelLayout';
import {
  hasFeatureCollectionWithGeometry,
  getFindingsSummaryFlags,
  SUMMARY_FETCH_TYPES,
} from '../../util/mapFindings.util';

interface IMapsFinding {
  gMap: any;
  gMaps: any;
  doStorageDownload: any;
  getStorageRef: any;
  setDownloadTriggers: any;
  downloadTriggers: any;
  context: IAuthContext;
  // Bootstrap column span for the panel's root <Col>. Defaults to 3 (the
  // /ai-earth layout). /phase1-agent renders it inside a fixed-width task
  // column, so it passes 12 to make the panel fill that column.
  cols?: number;
  // Extra pixels to subtract from the panel's viewport-pinned scroll heights
  // (`calc(100vh - …)`). Defaults to 0 (the /ai-earth layout). /phase1-agent
  // sits below an extra top address bar, so it passes that bar's height here to
  // shrink the inner scroll regions accordingly — keeping the findings header
  // fixed while making the last rows reachable.
  scrollOffset?: number;
}
const NoDataNote = styled.p`
  font-size: 12px;
  color: #aaa;
  font-style: italic;
  margin: 12px 0 0;
  text-align: center;
`;
const ButtonContainer: any = styled.div`
  display: flex;
  padding: 6px 10px;
  background-color: #000;
  flex-direction: row-reverse;
`;
const PreviewButtonContainer = styled(ButtonContainer)`
  background-color: #000;
  padding: 4px 10px;

  .btn,
  .btn-sm {
    background: #34d399 !important;
    border-color: #34d399 !important;
    color: #04130f !important;
  }

  .btn:hover,
  .btn:focus,
  .btn:active {
    background: #5eead4 !important;
    border-color: #5eead4 !important;
    color: #04130f !important;
    box-shadow: none !important;
  }
`;
const FilterFindings = styled.div`
  flex: 1;
`;
const FindingsDropdownPaper = styled(Paper)`
  background: #000 !important;
  color: #f8fafc !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;

  .MuiAutocomplete-option {
    color: #f8fafc !important;
    background: #000 !important;
  }

  .MuiAutocomplete-option[data-focus='true'] {
    background: rgba(52, 211, 153, 0.18) !important;
  }

  .MuiAutocomplete-option[aria-selected='true'] {
    background: rgba(52, 211, 153, 0.24) !important;
  }
`;
const CustomFormControl = styled(FormControl)`
  width: 100%;
  border-radius: 4px;

  .MuiInputLabel-root {
    color: #cbd5e1 !important;
  }

  .MuiInputLabel-root.Mui-focused {
    color: #34d399 !important;
  }

  .MuiOutlinedInput-root {
    color: #f8fafc !important;
    background: rgba(2, 7, 13, 0.9) !important;
  }

  .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: rgba(148, 163, 184, 0.35) !important;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(52, 211, 153, 0.6) !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #34d399 !important;
  }

  .MuiAutocomplete-popupIndicator {
    color: #34d399 !important;
  }
`;
const RNDataContainer: any = styled.div`
  padding: 5px 0px;
  height: calc(100vh - 170px);
  overflow: auto;
  background-color: rgba(2, 7, 13, 0.92);
  margin-right: 5px;
`;
const JobTasksContainer = styled(RNDataContainer)<{ $offset?: number }>`
  padding: 5px 0px;
  height: calc(100vh - ${(p: any) => 170 + (p.$offset ?? 0)}px);
  overflow: auto;
  background-color: rgba(2, 7, 13, 0.92);
  margin-right: 5px;
  border-left: 1px solid rgba(148, 163, 184, 0.2);
`;
const JobDetailsContainer = styled(RNDataContainer)`
  padding: 10px;
  height: calc(100vh - 170px);
  overflow: auto;
  background-color: rgba(2, 7, 13, 0.92);
  & h6 {
    color: #f8fafc;
  }
`;
const StyledDataTable = styled(DataTable)`
  background-color: #000;

  & .rdt_Table,
  & .rdt_TableHead,
  & .rdt_TableHeadRow,
  & .rdt_TableBody,
  & .rdt_TableRow {
    background-color: #000;
    color: #e2e8f0;
  }

  & .rdt_TableCell {
    font-size: 10px;
    padding: 3px;
    width: 9rem;
    text-overflow: ellipsis;
    color: #e2e8f0;
    background-color: #000;
  }
  & .rdt_TableCol {
    color: #cbd5e1;
    background-color: #000;
  }
  & .rdt_TableBody {
    overflow-y: scroll;
  }
  & .rdt_TableRow,
  .rdt_TableHeadRow {
    min-height: 36px;
  }
  & .rdt_TableRow,
  .rdt_TableCol {
    padding: 8px 10px;
    text-transform: uppercase;
  }
`;
const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2em 0em;
`;
const TableAstm = styled(Table)`
  width: 704px;
`;
const TD = styled.td`
  font-size: 12px;
  color: #e2e8f0 !important;
  background-color: rgba(2, 7, 13, 0.92) !important;
`;
const TH = styled.th`
  font-size: 12px;
  text-transform: uppercase;
  color: #f8fafc !important;
  background-color: rgba(15, 23, 42, 0.96) !important;
`;
const CustomTabs = styled(Tabs)`
  border-bottom: 1px solid rgba(52, 211, 153, 0.5) !important;
`;
const OLContainer = styled.ol`
  padding-inline-start: 10px !important;
  font-size: 0.6rem;
  padding-top: 7px;
  margin-bottom: 0px;
`;
const DownloadHyperlink = styled.a`
  color: #34d399;
  cursor: pointer;
  &:hover {
    color: #5eead4 !important;
    text-decoration: underline !important;
  }
`;
const AddressText = styled.span`
  display: block;
  font-size: 0.75rem;
  line-height: 1.4;
  color: #e2e8f0;
  margin: 0.35rem 0 0.25rem;
`;
const EnameText = styled.h6`
  color: #f8fafc !important;
`;
const SpaceEvenly = styled.div`
  display: flex;
  justify-content: space-between;
`;
const EPALink = styled.span`
  color: #34d399;
  cursor: pointer;
`;

const fetchRecordsByRN = (
  rnNumber: string,
  searchTerm: string,
  searchType: string
) => {
  return searchAIEarth({
    query: {
      from: 0,
      size: 50,
      sortByReleaseDate: true,
      text: searchTerm,
      type: searchType,
      terms: {
        regulated_entity_number: rnNumber,
      },
    },
  });
};

const RecordTable: React.FC<{
  columns: any;
  data: any;
  onFindingClick?: any;
  findingsRowStyles?: any;
  scrollHeight?: string;
}> = (props) => {
  return (
    <StyledDataTable
      columns={props.columns}
      data={props.data}
      noHeader={true}
      fixedHeaderScrollHeight={props.scrollHeight ?? 'calc(100vh - 240px)'}
      fixedHeader={true}
      pointerOnHover
      striped
      sortServer={true}
      onRowClicked={props.onFindingClick || undefined}
      highlightOnHover
      conditionalRowStyles={props.findingsRowStyles}
    />
  );
};

const MapsFinding: React.FC<IMapsFinding> = (props) => {
  const authContext = props.context;
  const colSpan = props.cols ?? 3;
  const scrollOffset = props.scrollOffset ?? 0;
  const findingsScrollHeight = `calc(100vh - ${240 + scrollOffset}px)`;
  const dispatch = useDispatch();
  const store: any = useSelector<any>((state): any => state);
  const jobState: IJob = store.job;
  const [getAutoScroll, setAutoScroll] = useState<boolean>(false);
  const [entityNumber, setEntityNumber] = useState<any>();
  const [getEntity, setEntity] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [entityDetails, setEntityDetails] = useState();
  const [isFindings, setIsFindings] = useState<boolean>(true);
  const [orphansFindings, setOrphansFindings] = useState<any>([]);
  const [relatedRecords, setRelatedRecords] = useState<ISearchRecord[]>([]);
  const documentsTabTitle = `Documents(${relatedRecords.length})`;
  const findingsDropdownValue = getFindingsTypeLabel(jobState.mapFindingsTypes);

  const onFindingClick = (row: any) => {
    setAutoScroll(false);
    getZoomPoint(row.geom);
    dispatch(
      updateJob({
        ...jobState,
        ...{
          jobInit: false,
          jobFeatureTab: true,
          mapFindingTab: true,
          jobFeature: row,
        },
      })
    );
  };
  const onOrphansClick = (row: any) => {
    setOrphansFindings(row);
    dispatch(
      updateJob({
        ...jobState,
        ...{
          jobFeatureTab: true,
        },
      })
    );
  };

  const propertiesCol = [
    {
      name: 'ID',
      selector: 'map_id',
      width: '40px',
    },
    {
      name: 'Vec',
      selector: 'vec_status',
      width: '80px',
    },
    {
      name: 'Rec',
      selector: 'rec_status',
      width: '80px',
    },
    {
      name: 'Entity Number',
      selector: 'entity_number',
      width: '120px',
    },
    {
      name: 'Entity Name',
      selector: 'entity_name',
      width: '120px',
    },
    {
      name: 'Address',
      selector: 'address',
      width: '150px',
    },
    {
      name: 'City',
      selector: 'city',
      width: '80px',
    },
    {
      name: 'State',
      selector: 'state',
      width: '50px',
    },
    {
      name: 'Zip',
      selector: 'zip_code',
      width: '60px',
    },
    {
      name: 'Programs',
      selector: 'programs',
      width: '70px',
    },
    {
      name: 'GW',
      selector: 'gw_flow',
      width: '70px',
    },
    {
      name: 'Elevation',
      selector: 'elevation',
      width: '70px',
    },
    {
      name: 'Distance',
      selector: 'distance_feet',
      width: '70px',
    },
  ];
  const orphansCol = [
    {
      name: 'Entity Name',
      selector: 'entity_name',
    },
    {
      name: 'Entity Number',
      selector: 'entity_number',
    },
    {
      name: 'Entity Source',
      selector: 'entity_source',
    },
    {
      name: 'Database',
      selector: 'programs',
    },
    {
      name: 'Address',
      selector: 'address',
    },
    {
      name: 'City',
      selector: 'city',
    },
    {
      name: 'Zip',
      selector: 'zip_code',
    },
    {
      name: 'Country',
      selector: 'county',
    },
    {
      name: 'Symbol',
      selector: 'program_symbol',
    },
    {
      name: 'State',
      selector: 'state',
    },
    {
      name: 'Secondary ID',
      selector: 'secondary_id',
    },
    {
      name: 'Street Name',
      selector: 'street_name',
    },
  ];
  const adjoiningCol = [
    {
      name: 'Address',
      selector: 'address',
    },
    {
      name: 'City',
      selector: 'city',
    },
    {
      name: 'County',
      selector: 'county',
    },
    {
      name: 'Direction',
      selector: 'direction',
    },
    {
      name: 'Distance',
      selector: 'distance_feet',
    },
    {
      name: 'Elevation',
      selector: 'elevation_feet',
    },
    {
      name: 'GW',
      selector: 'gw_flow',
    },
    {
      name: 'Legal',
      selector: 'legal',
    },
    {
      name: 'Mail Address',
      selector: 'mail_addr',
    },
    {
      name: 'Name',
      selector: 'name',
    },
    {
      name: 'Owner',
      selector: 'owner',
    },
    {
      name: 'State',
      selector: 'state',
    },
  ];

  useEffect(() => {
    async function getMapsFindingSummary() {
      dispatch(
        updateJob({
          ...jobState,
          ...{
            searchFinding: false,
          },
        })
      );
      try {
        const jobId = jobState.activeJob.jobId;
        const requestBody: any = { jobId };
        axios
          .post(
            API_BASE_URL +'/api/getMapsFindingSummary',
            // 'http://localhost:5000/ceres-platform-test/us-central1/api/document-entity/list',
            requestBody,
            {
              headers: API_AUTH_HEADERS,
            }
          )
          .then((response) => {
            const detailsJson = response.data?.[0]?.esadata_findings;
            dispatch(
              updateJob({
                ...jobState,
                ...{
                  esadataFindings: detailsJson || {},
                  searchFinding: false,
                },
              })
            );
          })
          .catch((err) => {
            CeresLogger.error(err);
          });
      } catch (e) {
        CeresLogger.error(e);
      }
    }
    if (jobState.searchFinding === true) {
      getMapsFindingSummary();
    }
  }, [
    jobState.mapFindingsTypes,
    isFindings,
    setIsFindings,
    jobState,
    dispatch,
  ]);

  useEffect(() => {
    async function programQueryDetails() {
      const requestBody = { RN: entityNumber };
      try {
        setIsLoading(true);
        axios
          .post(
            API_BASE_URL +'/api/programQueryDetails',
            // 'http://localhost:5000/ceres-platform-test/us-central1/api/document-entity/list',
            requestBody,
            {
              headers: API_AUTH_HEADERS,
            }
          )
          .then((response) => {
            setIsLoading(false);
            const detailsJson = response.data[0].get_prgm_json_for_entity;
            setEntityDetails(detailsJson);
          })
          .catch((err) => {
            CeresLogger.error(err);
            setIsLoading(false);
          })
          .finally(() => setIsLoading(false));
      } catch (e) {
        CeresLogger.error(e);
      }
    }

    async function fetchRecords() {
      let isSubscribed = true;
      const containsSearchTerm = await fetchRecordsByRN(
        entityNumber,
        '',
        'must'
      );
      const data = containsSearchTerm.data as IElasticResult<ISearchRecord>;
      const records = (data && data.records) || [];
      records.map((rec) => {
        rec.containsSearchTerm = true;
        return rec;
      });
      isSubscribed && setRelatedRecords(records);
      setIsLoading(false);
      return () => {
        isSubscribed = false;
      };
    }
    if (entityNumber) {
      programQueryDetails();
      fetchRecords();
    }
  }, [entityNumber, setIsLoading]);

  const getZoomPoint = (location: string) => {
    location = location.replace('POINT(', '');
    location = location.replace(')', '');
    const latLng = location.split(' ');
    const lat = latLng[1];
    const lng = latLng[0];
    if (lat && lng) {
      const latlng = new props.gMaps.LatLng(lat, lng);
      props.gMap.panTo(latlng);
      props.gMap.setZoom(18);
    }
  };

  const addjoinFindingsRowStyles = [
    {
      when: (row: any) => {
        if (row.ogc_fid === jobState.jobFeature.ogc_fid) {
          setEntity(row);
          if (getAutoScroll) {
            const index = jobState.mapFindings.findIndex(
              (x: any) => x.ogc_fid === jobState.jobFeature.ogc_fid
            );
            const list: any = document.getElementById('row-' + index);
            if (list) {
              list.scrollIntoView();
            }
          }
          return true;
        } else {
          return false;
        }
      },
      style: {
        // tslint:disable-next-line: object-literal-key-quotes
        backgroundColor: CommonBgColor.backgroundColor,
        // tslint:disable-next-line: object-literal-key-quotes
        color: 'white !important',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  ];

  const findingsRowStyles = [
    {
      when: (row: any) => {
        if (row.entity_number === jobState.jobFeature.entity_number) {
          setEntityNumber(row.entity_number);
          setEntity(row);
          if (getAutoScroll) {
            const index = jobState.mapFindings.findIndex(
              (x: any) => x.entity_number === jobState.jobFeature.entity_number
            );
            const list: any = document.getElementById('row-' + index);
            if (list) {
              list.scrollIntoView();
            }
          }
          return true;
        } else {
          return false;
        }
      },
      style: {
        // tslint:disable-next-line: object-literal-key-quotes
        backgroundColor: CommonBgColor.backgroundColor,
        // tslint:disable-next-line: object-literal-key-quotes
        color: 'white !important',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  ];
  const orphansRowStyles = [
    {
      when: (row: any) => {
        if (row.entity_number === orphansFindings.entity_number) {
          setEntityNumber(row.entity_number);
          setEntity(row);
          if (getAutoScroll) {
            const index = orphansFindings.findIndex(
              (x: any) => x.entity_number === orphansFindings.entity_number
            );
            const list: any = document.getElementById('row-' + index);
            if (list) {
              list.scrollIntoView();
            }
          }
          return true;
        } else {
          return false;
        }
      },
      style: {
        // tslint:disable-next-line: object-literal-key-quotes
        backgroundColor: CommonBgColor.backgroundColor,
        // tslint:disable-next-line: object-literal-key-quotes
        color: 'white !important',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  ];

  const getRecordTitle = (item: ISearchRecord) =>
    `${item.title} - ${item.seriesName} - ${item.releaseDate}`;

  const getTCEQRecordUrl = (eNumber: string) =>
    `https://www15.tceq.texas.gov/crpub/index.cfm?fuseaction=regent.validateRE&re_ref_num_txt=${eNumber}`;

  const getEPARecordUrl = (eNumber: string) =>
    `https://ofmpub.epa.gov/frs_public2/fii_map_master.fii_retrieve?fac_search=facility_uin&fac_value=${eNumber}&fac_search_type=Equal+To&postal_code=&location_address=&add_search_type=B&city_name=&county_name=&state_code=&epa_region_code=&cong_dist=&legis_dist=&huc_code=&fed_agency=&TribalLand=0&selectTribe=noselect&sic_type=Equal+to&sic_code_to=&naic_type=Equal+to&naic_to=&org_name=&duns_num=&contact_name=&prog_search=&int_search=&search_type=&search_type=all&all_programs=YES&sysname=&page_no=1&output_sql_switch=TRUE&report=1&database_type=FII&tribal_ind=&last_facility=&univ_search=&fac_search_term=&tribetype=&triballand=&selecttribe=&tribedistance1=`;

  const hasJobMapEntitiesData =
    jobState.esaData
    && Object.keys(jobState.esaData).length > 0
    && hasFeatureCollectionWithGeometry(jobState.esaData.regulated_entities_point)
    && Array.isArray(jobState.mapFindings)
    && jobState.mapFindings.length > 0;

  const hasAdjoiningFindingsData =
    jobState.esaData
    && Object.keys(jobState.esaData).length > 0
    && hasFeatureCollectionWithGeometry(jobState.esaData.adjoining_properties_boundaries)
    && Array.isArray(jobState.adjoiningPropertiesBoundaries)
    && jobState.adjoiningPropertiesBoundaries.length > 0;

  const findings = jobState.esadataFindings;
  const {
    hasAstmSummaryData,
    hasVecSummaryData,
    hasOilGasSummaryData,
    hasOrphansData,
    hasDatabaseDescriptionData,
    hasSoilsSummaryData,
  } = getFindingsSummaryFlags(findings);

  return (
    <>
      {jobState.mapFindingTab && !jobState.jobInit && (
        <Col lg={colSpan}>
          <PreviewButtonContainer>
            <Button
              style={{ padding: '5px' }}
              onClick={() => {
                dispatch(
                  updateJob({
                    ...jobState,
                    ...{
                      jobInit: true,
                      jobFeatureTab: false,
                      mapFindingTab: false,
                    },
                  })
                );
              }}
              size="sm"
            >
              <ChevronLeft />
            </Button>
            <FilterFindings>
              <CustomFormControl size="small" variant="outlined">
                <Autocomplete
                  PaperComponent={FindingsDropdownPaper as any}
                  options={FINDINGS_OPTIONS}
                  value={findingsDropdownValue}
                  getOptionLabel={(option: any) => option}
                  getOptionSelected={(option: string, value: string) =>
                    option === value
                  }
                  onChange={(event: any, newValue: any) => {
                    dispatch(
                      updateJob({
                        ...jobState,
                        ...{
                          jobFeatureTab: false,
                          mapFindingsTypes: newValue,
                          ...(SUMMARY_FETCH_TYPES.has(newValue)
                            ? { searchFinding: true }
                            : {}),
                        },
                      })
                    );
                  }}
                  style={{ width: '100%' }}
                  disableClearable
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      label="Findings"
                      variant="outlined"
                      size="small"
                    />
                  )}
                />
              </CustomFormControl>
            </FilterFindings>
          </PreviewButtonContainer>
          <JobTasksContainer $offset={scrollOffset}>
            {jobState.mapFindingsTypes === 'Job Map Entities' && hasJobMapEntitiesData && (
                <RecordTable
                  columns={propertiesCol}
                  data={jobState.mapFindings}
                  onFindingClick={onFindingClick}
                  findingsRowStyles={findingsRowStyles}
                  scrollHeight={findingsScrollHeight}
                />
              )}
            {jobState.mapFindingsTypes === 'Job Map Entities' && !hasJobMapEntitiesData && (
              <NoDataNote>No data</NoDataNote>
            )}
            {jobState.mapFindingsTypes === 'ASTM Summary' && hasAstmSummaryData && (
                <div className="table-responsive">
                  <TableAstm bordered hover>
                    <thead>
                      <tr>
                        <TH>Database</TH>
                        <TH>DIST(MI)</TH>
                        <TH>TP</TH>
                        <TH>{'> tp < 1/8'}</TH>
                        <TH>{'1/8 - < 1/4'}</TH>
                        <TH>{'1/4 - < 1/2'}</TH>
                        <TH>1/2 - 1</TH>
                        <TH>{'> 1'}</TH>
                        <TH>Total</TH>
                      </tr>
                    </thead>
                    <tbody>
                      {findings.map_findings_summary_astm.map(
                        (astm: any, key: any) => (
                          <React.Fragment key={`${key}${astm.group}`}>
                            <tr>
                              <TD colSpan={9}>{astm.group}</TD>
                            </tr>
                            {Array.isArray(astm.summary) &&
                              astm.summary.map((summary: any, keys: any) => (
                                <tr key={`${keys}${summary['prgm']}`}>
                                  <TD>{summary['prgm']}</TD>
                                  <TD>{summary['dist(mi)']}</TD>
                                  <TD>{summary['tp']}</TD>
                                  <TD>{summary['> tp < 1/8']}</TD>
                                  <TD>{summary['1/8 - < 1/4']}</TD>
                                  <TD>{summary['1/4 - < 1/2']}</TD>
                                  <TD>{summary['1/2 - 1']}</TD>
                                  <TD>{summary['> 1']}</TD>
                                  <TD>{summary['Total']}</TD>
                                </tr>
                              ))}
                          </React.Fragment>
                        )
                      )}
                    </tbody>
                  </TableAstm>
                </div>
              )}
            {jobState.mapFindingsTypes === 'ASTM Summary' && !hasAstmSummaryData && (
              <NoDataNote>No data</NoDataNote>
            )}
            {jobState.mapFindingsTypes === 'VEC Summary' && hasVecSummaryData && (
                <Table bordered hover>
                  <thead>
                    <tr>
                      <TH>Database</TH>
                      <TH>TP</TH>
                      <TH>Crossgradient</TH>
                      <TH>Downgradient</TH>
                      <TH>Upgradient</TH>
                      <TH>Total</TH>
                    </tr>
                  </thead>
                  <tbody>
                    {findings.map_findings_summary_vec.map((vec: any, vecKey: number) => (
                      <React.Fragment key={vecKey}>
                        <tr>
                          <TD colSpan={6}>{vec.group}</TD>
                        </tr>
                        {Array.isArray(vec.summary) &&
                          vec.summary.map((summary: any, summaryKey: number) => (
                            <tr key={summaryKey}>
                              <TD>{summary['prgm']}</TD>
                              <TD>{summary['tp']}</TD>
                              <TD>{summary['crossgradient']}</TD>
                              <TD>{summary['downgradient']}</TD>
                              <TD>{summary['upgradient']}</TD>
                              <TD>{summary['Total']}</TD>
                            </tr>
                          ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>
              )}
            {jobState.mapFindingsTypes === 'VEC Summary' && !hasVecSummaryData && (
              <NoDataNote>No data</NoDataNote>
            )}
            {jobState.mapFindingsTypes === 'Oil-Gas Summary' && hasOilGasSummaryData && (
                <TableAstm bordered hover>
                  <thead>
                    <tr>
                      <TH>Database</TH>
                      <TH>TP</TH>
                      <TH>{'1/4 - < 1/2'}</TH>
                      <TH>{'1/8 - < 1/4'}</TH>
                      <TH>{'> 1/2'}</TH>
                      <TH>{'> tp < 1/8'}</TH>
                      <TH>Total</TH>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <TD colSpan={7}>
                        {findings.map_findings_summary_oil_gas.group}
                      </TD>
                    </tr>
                    {findings.map_findings_summary_oil_gas.summary.map(
                      (summary: any, summaryKey: number) => (
                        <tr key={summaryKey}>
                          <TD>{summary['prgm']}</TD>
                          <TD>{summary['tp']}</TD>
                          <TD>{summary['1/4 - < 1/2']}</TD>
                          <TD>{summary['1/8 - < 1/4']}</TD>
                          <TD>{summary['> 1/2']}</TD>
                          <TD>{summary['> tp < 1/8']}</TD>
                          <TD>{summary['Total']}</TD>
                        </tr>
                      )
                    )}
                  </tbody>
                </TableAstm>
              )}
            {jobState.mapFindingsTypes === 'Oil-Gas Summary' && !hasOilGasSummaryData && (
              <NoDataNote>No data</NoDataNote>
            )}

            {jobState.mapFindingsTypes === 'Database Description' && hasDatabaseDescriptionData && (
                <DatabaseDescription />
              )}
            {jobState.mapFindingsTypes === 'Database Description' && !hasDatabaseDescriptionData && (
              <NoDataNote>No data</NoDataNote>
            )}

            {jobState.mapFindingsTypes === 'Soils Summary' && hasSoilsSummaryData && <SoilSummary />}
            {jobState.mapFindingsTypes === 'Soils Summary' && !hasSoilsSummaryData && (
              <NoDataNote>No data</NoDataNote>
            )}

            {jobState.mapFindingsTypes === 'Orphans Summary' && hasOrphansData && (
                <StyledDataTable
                  columns={orphansCol}
                  data={jobState.esadataFindings.orphans}
                  noHeader={true}
                  fixedHeaderScrollHeight={findingsScrollHeight}
                  fixedHeader={true}
                  pointerOnHover
                  striped
                  sortServer={true}
                  onRowClicked={onOrphansClick || undefined}
                  highlightOnHover
                  conditionalRowStyles={orphansRowStyles}
                />
              )}
            {jobState.mapFindingsTypes === 'Orphans Summary' && !hasOrphansData && (
              <NoDataNote>No data</NoDataNote>
            )}
            {isAdjoiningFindingsType(jobState.mapFindingsTypes) && hasAdjoiningFindingsData && (
                <RecordTable
                  columns={adjoiningCol}
                  data={jobState.adjoiningPropertiesBoundaries}
                  findingsRowStyles={addjoinFindingsRowStyles}
                  scrollHeight={findingsScrollHeight}
                />
              )}
            {isAdjoiningFindingsType(jobState.mapFindingsTypes) && !hasAdjoiningFindingsData && (
              <NoDataNote>No data</NoDataNote>
            )}
          </JobTasksContainer>
        </Col>
      )}
      {jobState.jobFeatureTab && (
        <Col lg={colSpan}>
          <ButtonContainer>
            <Button
              style={{ padding: '5px' }}
              onClick={() => {
                dispatch(
                  updateJob({
                    ...jobState,
                    ...{
                      jobFeatureTab: false,
                    },
                  })
                );
              }}
              size="sm"
            >
              <ChevronLeft />
            </Button>
          </ButtonContainer>
          <JobDetailsContainer>
            {isLoading ? (
              <SpinnerContainer>
                <Spinner animation="border" variant="primary" />
              </SpinnerContainer>
            ) : (
              <>
                <EnameText>{getEntity.entity_name}</EnameText>
                <AddressText>{getEntity.address}</AddressText>
                <h6>
                  <SpaceEvenly>
                    {getEntity.entity_source === 'TCEQ' && (
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={getTCEQRecordUrl(entityNumber)}
                      >
                        {entityNumber}
                      </a>
                    )}
                    {getEntity.entity_source === 'EPA' && (
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={getEPARecordUrl(entityNumber)}
                      >
                        {entityNumber}
                      </a>
                    )}
                    {getEntity.entity_source === 'TCEQ-EPA' && (
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={getTCEQRecordUrl(entityNumber)}
                      >
                        {entityNumber}
                      </a>
                    )}
                    {getEntity.secondary_id && (
                      <OverlayTrigger
                        trigger="click"
                        rootClose
                        placement="bottom"
                        overlay={
                          <Popover id="popover">
                            <Popover.Title>EPA IDs</Popover.Title>
                            <Popover.Content>
                              {getEntity.secondary_id
                                .split(',')
                                .map((epaId: any) => {
                                  if (
                                    epaId.startsWith('11') &&
                                    epaId.length === 12
                                  ) {
                                    return (
                                      <p>
                                        <a
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          href={getEPARecordUrl(epaId)}
                                        >
                                          {epaId}
                                        </a>
                                      </p>
                                    );
                                  }
                                  return '';
                                })}
                            </Popover.Content>
                          </Popover>
                        }
                      >
                        <EPALink>EPA IDs</EPALink>
                      </OverlayTrigger>
                    )}
                  </SpaceEvenly>
                </h6>
                <CustomTabs
                  defaultActiveKey="details"
                  id="uncontrolled-tab-example"
                >
                  <Tab eventKey="details" title="Details">
                    <TreeView details={entityDetails} />
                  </Tab>
                  <Tab eventKey="documents" title={documentsTabTitle}>
                    <OLContainer>
                      <Scrollbars
                        style={{
                          height: 'calc(100vh - 305px)',
                        }}
                      >
                        {R.compose(
                          R.map((relatedRecord: ISearchRecord) => {
                            return (
                              <li
                                style={{
                                  color: relatedRecord.containsSearchTerm
                                    ? 'green'
                                    : 'none',
                                }}
                                key={relatedRecord.contentId}
                              >
                                {authContext.isTier(TIERS.FREE) && !authContext.isLubrizol() ? (
                                  getRecordTitle(relatedRecord)
                                ) : (
                                  <DownloadHyperlink
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (
                                        props.doStorageDownload(
                                          relatedRecord.entitySource
                                        )
                                      ) {
                                        const storageRef = props.getStorageRef(
                                          relatedRecord.entitySource
                                        );
                                        if (R.isNil(storageRef)) {
                                          return toast.error(
                                            `Oops, could not find the file.`
                                          );
                                        }
                                        props.setDownloadTriggers(
                                          R.append(
                                            relatedRecord.contentId,
                                            props.downloadTriggers
                                          )
                                        );
                                        return storageRef
                                          .ref(relatedRecord.fileName)
                                          .getDownloadURL()
                                          .then((url: string | undefined) =>
                                            window.open(
                                              url,
                                              '_blank',
                                              'noopener,noreferrer'
                                            )
                                          )
                                          .catch((err: any) =>
                                            toast.error(err.message)
                                          )
                                          .finally(() =>
                                            props.setDownloadTriggers(
                                              R.without(
                                                [relatedRecord.contentId],
                                                props.downloadTriggers
                                              )
                                            )
                                          );
                                      }
                                      if (!relatedRecord.fileUrl) {
                                        return toast.warn(
                                          <span>
                                            No associated file was found for the
                                            content id{' '}
                                            <b>{relatedRecord.contentId}</b>
                                          </span>
                                        );
                                      }
                                      window.open(
                                        relatedRecord.fileUrl,
                                        '_blank'
                                      );
                                      // props.setRelatedDocument(relatedRecord);
                                    }}
                                  >
                                    {getRecordTitle(relatedRecord)}
                                  </DownloadHyperlink>
                                )}
                              </li>
                            );
                          }),
                          R.sort(
                            R.comparator(
                              (
                                itemOne: ISearchRecord,
                                itemTwo: ISearchRecord
                              ) => itemOne.releaseDate > itemTwo.releaseDate
                            )
                          )
                        )(relatedRecords)}
                        {relatedRecords.length < 1
                          ? 'No documents currently available.'
                          : ''}
                      </Scrollbars>
                    </OLContainer>
                  </Tab>
                </CustomTabs>
              </>
            )}
          </JobDetailsContainer>
        </Col>
      )}
    </>
  );
};
export default MapsFinding;
